import React, { FocusEventHandler, MouseEventHandler } from "react";
import "./UnstyledButton.css"

export interface UnstyledButtonProps {
    id?: string;
    onClick: MouseEventHandler;
    onFocus?: FocusEventHandler<HTMLButtonElement>;
    className?: string;
    children?: React.ReactNode;
    title?: string;
    style?: React.CSSProperties;
    disabled?: boolean;
    tabIndex?: number;
}

export default function (props: UnstyledButtonProps) {
    return (
        <button
            type="button"
            id={props.id}
            title={props.title}
            className={"unstyled-button " + (props.className || "")}
            onClick={props.onClick}
            style={props.style}
            disabled={props.disabled}
            onFocus={props.onFocus}
            tabIndex={props.tabIndex}>
            {props.children}
        </button>
    );
}